import { useState } from 'react';
import { PlaybackState } from 'components/Player';
import VisuallyHidden from 'components/VisuallyHidden';

export type CondensedPlaybackButtonAriaProps = {
  /**
   * Title of the video to announce to screenreaders.  Used for unique player
   * component labels when multiple players are visible in the widget at once
   */
  ariaVideoTitle?: string;
  isLoading: boolean | undefined;
  status: PlaybackState;
};

const LOADING_STARTED_MESSAGE = 'video is loading';
const LOADING_FINISHED_MESSAGE = 'video finished loading';

const CondensedPlaybackButtonAria: React.FC<
  CondensedPlaybackButtonAriaProps
> = ({
  ariaVideoTitle,
  isLoading,
  status,
}: CondensedPlaybackButtonAriaProps) => {
  const [liveMessage, setLiveMessage] = useState<string>();
  const [prevIsLoading, setPrevIsLoading] = useState<boolean>();

  if (prevIsLoading !== isLoading) {
    setPrevIsLoading(isLoading);

    if (isLoading) {
      setLiveMessage(LOADING_STARTED_MESSAGE);
    } else {
      setLiveMessage(LOADING_FINISHED_MESSAGE);
    }
  }

  return (
    <>
      <VisuallyHidden>
        {[status === 'playing' ? 'pause' : 'play', ariaVideoTitle]
          .filter(Boolean)
          .join(' ')}
      </VisuallyHidden>
      <VisuallyHidden aria-live="polite">
        {status === 'playing' ? liveMessage : null}
      </VisuallyHidden>
    </>
  );
};

export default CondensedPlaybackButtonAria;
